// ── Announcement Bar ────────────────────────────────────────
const announcementBar   = document.getElementById('announcement-bar');
const announcementClose = document.getElementById('announcement-close');

if (announcementClose) {
  announcementClose.addEventListener('click', () => {
    announcementBar.classList.add('dismissed');
  });
}

// ── Mobile Menu ───────────────────────────────────────────
// 2026-07-28: this block used to target #hamburger / #mobile-menu /
// #mobile-overlay / #mobile-menu-close. None of those IDs exist — header.liquid
// renders #menu-btn / #mobile-nav / #nav-overlay / #mobile-nav-close. So
// closeMenu() threw a TypeError on a null every time it ran, which broke two
// things that called it: the Escape handler (closeCart() after it never ran, so
// Escape closed nothing) and every in-page anchor link (preventDefault fired,
// then the throw stopped the scrollIntoView, so the link did nothing).
// Repointed at the real elements; opening is still owned by header.liquid.
const mobileMenu    = document.getElementById('mobile-nav');
const mobileOverlay = document.getElementById('nav-overlay');
const hamburger     = document.getElementById('menu-btn');

function closeMenu() {
  if (!mobileMenu) return;
  mobileMenu.classList.remove('open');
  mobileMenu.setAttribute('aria-hidden', 'true');
  mobileMenu.setAttribute('inert', '');
  if (mobileOverlay) mobileOverlay.classList.remove('visible');
  if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('nav-open');
}

// Tapping any link inside the drawer should dismiss it, so returning via the
// back button never lands on a page with the menu still hanging open.
if (mobileMenu) {
  mobileMenu.addEventListener('click', e => {
    if (e.target.closest('a[href]')) closeMenu();
  });
}

// Escape key handled in Subscribe Modal section below

// ── Cart Drawer ────────────────────────────────────────────
// ponytail: IDs realigned to the header.liquid markup (menu-btn/mobile-nav/cart-* scheme).
// header renders #cart-close/#cart-body/#cart-count/#cart-subtotal and .cart-drawer-footer (class, no id).
const cartBtn     = document.getElementById('cart-btn');
const cartDrawer  = document.getElementById('cart-drawer');
const cartClose   = document.getElementById('cart-close');
const cartOverlay = document.getElementById('cart-overlay');
const cartBody    = document.getElementById('cart-body');
const cartFooter  = document.querySelector('.cart-drawer-footer');
const bagCount    = document.getElementById('cart-count');
const cartTotal   = document.getElementById('cart-subtotal');

const FREE_SHIPPING_THRESHOLD = 150;

// ── Cart Open / Close ────────────────────────────────────────
// body.cart-open carries both overflow:hidden and touch-action:none. The old
// inline body.style.overflow locked scroll on desktop but not reliably on iOS,
// where overflow alone does not stop a touch drag.
function openCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.add('open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  cartDrawer.removeAttribute('inert');
  if (cartOverlay) cartOverlay.classList.add('visible');
  document.body.classList.add('cart-open');
}

function closeCart() {
  if (!cartDrawer) return;
  cartDrawer.classList.remove('open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  cartDrawer.setAttribute('inert', '');
  if (cartOverlay) cartOverlay.classList.remove('visible');
  document.body.classList.remove('cart-open');
}

if (cartBtn)     cartBtn.addEventListener('click', e => { e.preventDefault(); fetchAndRenderCart(); openCart(); });
if (cartClose)   cartClose.addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

// ── Shopify AJAX Cart ────────────────────────────────────────
async function shopifyPost(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) throw new Error(`Cart error: ${res.status}`);
  return res.json();
}

async function fetchAndRenderCart() {
  const data = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
  const count       = data.item_count;
  const totalCents  = data.total_price;
  const totalDollars = Math.round(totalCents / 100);

  if (bagCount) {
    bagCount.textContent = count;
    bagCount.classList.add('bump');
    setTimeout(() => bagCount.classList.remove('bump'), 300);
  }
  if (!cartBody) return;

  if (count === 0) {
    cartBody.classList.remove('has-items');
    cartBody.innerHTML = `
      <p class="cart-empty-msg">Your bag is empty.</p>
      <a href="/collections/all" class="btn btn-solid cart-continue-btn" id="cart-continue-new">Continue Shopping</a>
    `;
    document.getElementById('cart-continue-new')?.addEventListener('click', () => closeCart());
    if (cartFooter) cartFooter.hidden = true;
  } else {
    cartBody.classList.add('has-items');
    const toFree   = Math.max(0, FREE_SHIPPING_THRESHOLD * 100 - totalCents);
    const progress = Math.min(100, (totalCents / (FREE_SHIPPING_THRESHOLD * 100)) * 100);
    const shippingMsg = toFree > 0
      ? `You're <strong>$${Math.round(toFree / 100)}</strong> away from free shipping`
      : `<span class="cart-shipping-unlocked">Free shipping unlocked</span>`;

    cartBody.innerHTML = `
      <div class="cart-shipping-bar">
        <p class="cart-shipping-bar-msg">${shippingMsg}</p>
        <div class="cart-shipping-progress">
          <div class="cart-shipping-fill" style="width:${progress}%"></div>
        </div>
      </div>
      <div class="cart-items-list">
        ${data.items.map(item => {
          const sizeLabel = item.properties && item.properties.Size ? ` · ${item.properties.Size}` : '';
          const variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
          const subtitle = [variantLabel, item.properties?.Size].filter(Boolean).join(' · ');
          return `
            <div class="cart-item">
              ${item.image ? `<img src="${item.image}" alt="${item.product_title}" class="cart-item-img" loading="lazy">` : ''}
              <div class="cart-item-details">
                <p class="cart-item-name">${item.product_title}</p>
                ${subtitle ? `<p class="cart-item-variant">${subtitle}</p>` : ''}
                <div class="cart-item-bottom">
                  <p class="cart-item-price">$${Math.round(item.final_line_price / 100)}</p>
                  <div class="cart-qty-ctrl">
                    <button class="cart-qty-btn" data-action="dec" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease quantity">−</button>
                    <span class="cart-qty-num">${item.quantity}</span>
                    <button class="cart-qty-btn" data-action="inc" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase quantity">+</button>
                  </div>
                </div>
                <button class="cart-item-remove" data-key="${item.key}">Remove</button>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    `;

    cartBody.querySelectorAll('.cart-qty-btn').forEach(btn => {
      btn.addEventListener('click', async () => {
        const currentQty = parseInt(btn.dataset.qty);
        const newQty = btn.dataset.action === 'inc' ? currentQty + 1 : currentQty - 1;
        btn.disabled = true;
        await shopifyPost('/cart/change.js', { id: btn.dataset.key, quantity: Math.max(0, newQty) });
        fetchAndRenderCart();
      });
    });

    cartBody.querySelectorAll('.cart-item-remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        await shopifyPost('/cart/change.js', { id: btn.dataset.key, quantity: 0 });
        fetchAndRenderCart();
      });
    });

    if (cartTotal) cartTotal.textContent = `$${totalDollars}`;
    if (cartFooter) cartFooter.hidden = false;
  }
}

// ── (removed 2026-09: legacy pre-order size picker; product form now posts via the section's ajax handler) ──

// ── Header scroll shadow ──────────────────────────────────────────
const siteHeader = document.getElementById('site-header');

window.addEventListener('scroll', () => {
  siteHeader.classList.toggle('scrolled', window.scrollY > 10);
}, { passive: true });

// ── Hero bg subtle zoom on load ──────────────────────────────────────────
const heroBg = document.querySelector('.hero-bg');
if (heroBg) {
  window.addEventListener('load', () => {
    heroBg.classList.add('loaded');
  });
}

// ── Scroll Reveal (IntersectionObserver) ────────────────────────────────────
const revealEls = document.querySelectorAll('.reveal');

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, {
  threshold: 0.12,
  rootMargin: '0px 0px -40px 0px',
});

revealEls.forEach((el) => revealObserver.observe(el));

document.querySelectorAll('.product-card.reveal').forEach((card, i) => {
  card.style.transitionDelay = `${i * 0.12}s`;
});

// ── Testimonial Carousel ─────────────────────────────────────────
const testimonialCards = document.querySelectorAll('.testimonial-card');
const dots = document.querySelectorAll('.dot');
let currentTestimonial = 0;
let testimonialInterval;

function showTestimonial(index) {
  testimonialCards.forEach(card => card.classList.remove('active'));
  dots.forEach(dot => dot.classList.remove('active'));
  testimonialCards[index].classList.add('active');
  dots[index].classList.add('active');
  currentTestimonial = index;
}

function nextTestimonial() {
  const next = (currentTestimonial + 1) % testimonialCards.length;
  showTestimonial(next);
}

if (testimonialCards.length > 1) {
  testimonialInterval = setInterval(nextTestimonial, 5000);

  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      clearInterval(testimonialInterval);
      showTestimonial(parseInt(dot.dataset.index));
      testimonialInterval = setInterval(nextTestimonial, 5000);
    });
  });
}

// ── Klaviyo Popup Form ────────────────────────────────────────
const KLAVIYO_FORM_ID = 'STKrsE';

(function setupKlaviyoOpenButton() {
  // Klaviyo writes a `disabledForms[<formId>].lastCloseTime` entry into
  // localStorage.klaviyoOnsite after a popup is dismissed, and refuses to
  // re-show the same form for the rest of the session. We clear that entry
  // before each open call so the CTA always re-opens the popup.
  function clearKlaviyoDismissalFlag() {
    try {
      var key = 'klaviyoOnsite';
      var raw = localStorage.getItem(key);
      if (!raw) return;
      var state = JSON.parse(raw);
      if (state && state.viewedForms && state.viewedForms.modal) {
        var modal = state.viewedForms.modal;
        if (modal.disabledForms) delete modal.disabledForms[KLAVIYO_FORM_ID];
        if (modal.viewedForms)   delete modal.viewedForms[KLAVIYO_FORM_ID];
      }
      localStorage.setItem(key, JSON.stringify(state));
    } catch (err) { /* localStorage unavailable / parse error, ignore */ }
  }

  function openForm() {
    clearKlaviyoDismissalFlag();
    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(KLAVIYO_FORM_ID);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', KLAVIYO_FORM_ID]);
    }
  }

  function bind() {
    var existing = document.getElementById('kl-open-btn');
    if (!existing) return;
    // Clone strips any listeners auto-attached by Klaviyo's onsite SDK so
    // only our handler runs.
    var clone = existing.cloneNode(true);
    existing.parentNode.replaceChild(clone, existing);
    clone.addEventListener('click', function (e) {
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
      openForm();
    });
  }
  setTimeout(bind, 600);
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) setTimeout(bind, 100); });
})();

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeMenu();
    closeCart();
  }
});

// ── Countdown to July 1 2026 ────────────────────────────────────────
(function() {
  const target = new Date('2026-07-01T00:00:00').getTime();
  const pad = n => n < 10 ? '0' + n : '' + n;
  function tick() {
    const diff = Math.max(0, target - Date.now());
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    const el = id => document.getElementById(id);
    if (el('cd-days'))  el('cd-days').textContent  = pad(d);
    if (el('cd-hours')) el('cd-hours').textContent = pad(h);
    if (el('cd-mins'))  el('cd-mins').textContent  = pad(m);
    if (el('cd-secs'))  el('cd-secs').textContent  = pad(s);
    if (diff > 0) setTimeout(tick, 1000);
  }
  tick();
})();

// ── Smooth scroll for anchor links ───────────────────────────────────
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      closeMenu();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

// ── Policy page enhancer ────────────────────────────────────
(function() {
  const titleWrap = document.querySelector('.shopify-policy__title');
  const bodyWrap  = document.querySelector('.shopify-policy__body .rte');
  if (!titleWrap || !bodyWrap) return;

  // Inject eyebrow + divider into the hero
  const h1 = titleWrap.querySelector('h1');
  if (h1) {
    const eyebrow = document.createElement('span');
    eyebrow.className = 'policy-hero-eyebrow';
    eyebrow.textContent = 'Manemy™';
    titleWrap.insertBefore(eyebrow, h1);

    const divider = document.createElement('div');
    divider.className = 'policy-hero-divider';
    titleWrap.appendChild(divider);
  }

  // Shopify policy body: headings are plain text before <br> in a <p>.
  // Pattern: <p>Heading Text  <br>Body line 1  <br>Body line 2</p>
  // Standalone <p> without <br> is continuation text.
  const paragraphs = Array.from(bodyWrap.querySelectorAll('p'));
  const sections = [];
  let introLines = [];
  let currentTitle = null;
  let currentLines = [];
  let foundFirst = false;

  const knownHeadings = [
    'Shipping Policy', 'In-Stock Items', 'Pre-Order Items',
    'Total Delivery Time', 'Shipping Rates', 'Order Tracking',
    'Delays', 'Incorrect Address', 'Returns', 'Refund', 'Privacy',
    'Contact', 'Terms'
  ];

  function flush() {
    if (currentTitle) sections.push({ title: currentTitle, lines: currentLines });
    currentTitle = null;
    currentLines = [];
  }

  function hasBr(p) { return p.querySelector('br') !== null; }

  function splitAtBr(p) {
    const clone = p.cloneNode(true);
    clone.querySelectorAll('br').forEach(function(br) { br.replaceWith('\n'); });
    return clone.textContent.split('\n').map(function(l) { return l.trim(); }).filter(Boolean);
  }

  paragraphs.forEach(function(p) {
    const text = p.textContent.trim();
    if (!text || text === '---') return;
    if (text.startsWith('Manemy') && text.includes('Minimal luxury')) return;

    if (hasBr(p)) {
      const lines = splitAtBr(p);
      if (lines.length < 2) return;
      const candidate = lines[0];
      const isHeading = knownHeadings.some(function(h) { return candidate.indexOf(h) !== -1; }) ||
                        (candidate.length <= 50 && /^[A-Z]/.test(candidate));

      if (isHeading) {
        flush();
        foundFirst = true;
        currentTitle = candidate;
        lines.slice(1).forEach(function(l) { currentLines.push(l); });
        return;
      }
    }

    // First paragraph "Shipping Policy" (no <br>) — skip as redundant with h1
    if (!foundFirst && text === 'Shipping Policy') return;

    if (!foundFirst) {
      introLines.push(text);
    } else {
      const lines = hasBr(p) ? splitAtBr(p) : [text];
      lines.forEach(function(l) { currentLines.push(l); });
    }
  });
  flush();

  // Build new HTML
  let html = '';
  if (introLines.length) {
    html += '<div class="policy-intro">' + introLines.map(function(l) { return '<p>' + l + '</p>'; }).join('') + '</div>';
  }
  sections.forEach(function(s) {
    html += '<div class="policy-section"><h2 class="policy-section-title">' + s.title + '</h2><div class="policy-section-text">';
    s.lines.forEach(function(l) { html += '<p>' + l + '</p>'; });
    html += '</div></div>';
  });

  if (html) bodyWrap.innerHTML = html;

  // Add related policies and back link
  const currentPath = window.location.pathname;
  const policies = [
    { href: '/policies/shipping-policy', label: 'Shipping' },
    { href: '/policies/refund-policy', label: 'Returns & Refunds' }
  ];

  const container = document.querySelector('.shopify-policy__container');
  if (!container) return;

  const related = document.createElement('div');
  related.className = 'policy-related';
  related.innerHTML = '<span class="policy-related-label">Other Policies</span><div class="policy-related-links">' +
    policies.map(function(p) {
      const isCurrent = currentPath.indexOf(p.href) !== -1;
      return '<a href="' + p.href + '" class="policy-related-link' + (isCurrent ? ' is-current' : '') + '">' + p.label + '</a>';
    }).join('') + '</div>';
  container.appendChild(related);

  const backRow = document.createElement('div');
  backRow.className = 'policy-back-row';
  backRow.innerHTML = '<a href="/" class="policy-back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M19 12H5m0 0l6-6m-6 6l6 6"/></svg> Back to Home</a>';
  container.appendChild(backRow);
})();

// ── Lazy video sources (LCP fix) ──────────────────────────────────────────
// Hero/motion videos ship with no src; the poster paints immediately and is
// the LCP. Sources attach after window load, only at/above each video's
// data-min viewport width (mobile keeps the poster, zero video bytes).
(function () {
  // 2026-09: sources now attach only when the video is within 600px of the
  // viewport (IntersectionObserver). Same guards as before: no-op if src is
  // already set, prefers-reduced-motion, data-min viewport width, empty src.
  // Without IntersectionObserver the old attach-on-load behavior is kept.
  function attachOne(v) {
    if (v.src) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var min = parseInt(v.dataset.min || '0', 10);
    if (window.innerWidth < min) return;
    var src = v.dataset.srcHd || v.dataset.srcSd;
    if (!src) return;
    v.src = src;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      attachOne(entry.target);
      if (entry.target.src) io.unobserve(entry.target);
    });
  }, { rootMargin: '600px 0px' }) : null;
  function attachLazyVideos() {
    document.querySelectorAll('video[data-lazy-video]').forEach(function (v) {
      if (v.src) return;
      if (io) { io.unobserve(v); io.observe(v); } // re-observe so the current viewport is re-evaluated
      else attachOne(v);
    });
  }
  if (document.readyState === 'complete') attachLazyVideos();
  else window.addEventListener('load', attachLazyVideos);
  // Re-check when the viewport gets real dimensions (prerendered/hidden pages
  // report innerWidth 0 at load); the v.src guard makes repeat calls a no-op.
  window.addEventListener('resize', attachLazyVideos);
  document.addEventListener('visibilitychange', attachLazyVideos);
})();
